// AUTO-GENERATED from `bush_2.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 45590,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 13552830,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 0.5,
        "y": 5
      }
    },
    "branch": {
      "levels": 2,
      "angle": {
        "1": 19.565217391304348,
        "2": 27.39130434782609,
        "3": 60
      },
      "children": {
        "0": 10,
        "1": 3,
        "2": 2
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0
      },
      "gnarliness": {
        "0": 0.021739130434782594,
        "1": 0.10869565217391308,
        "2": 0.05,
        "3": 0.09
      },
      "length": {
        "0": 0.1,
        "1": 19.645652173913046,
        "2": 7.701086956521739,
        "3": 4.6
      },
      "radius": {
        "0": 0.5793478260869566,
        "1": 0.9521739130434783,
        "2": 0.76,
        "3": 0.7
      },
      "sections": {
        "0": 3,
        "1": 4,
        "2": 10,
        "3": 10
      },
      "segments": {
        "0": 4,
        "1": 4,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.6413043478260869,
        "2": 0.7065217391304348,
        "3": 0
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0.3586956521739131,
        "1": -0.043478260869565244,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "aspen",
      "billboard": "double",
      "angle": 55,
      "count": 7,
      "start": 0,
      "size": 2.4456521739130435,
      "sizeVariance": 0.717,
      "tint": 14745557,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
